<script setup lang="ts">
import {useDisplay} from "vuetify";
import {route} from "ziggy-js";
import {computed} from "vue";
import {usePage} from "@inertiajs/vue3";

const emit = defineEmits(['showSearchDialog'])

const {smAndDown} = useDisplay()

const page = usePage()

const value = computed(() => page.props.search as string || '')
</script>

<template>
    <v-btn
        v-if="smAndDown"
        class="border"
        icon="mdi-inbox-outline"
        size="x-small"
        rounded="lg"
        @click="$emit('showSearchDialog')"
    >
        <v-icon
            size="20"
            color="grey-darken-3"
        >
            mdi-magnify
        </v-icon>
    </v-btn>
    <v-text-field
        v-if="!smAndDown"
        :value="value"
        variant="outlined"
        density="compact"
        rounded="lg"
        :readonly="true"
        :class="route().current('search') ? 'ml-3' : null"
        :style="route().current('search') ? 'max-width: 100%' : 'max-width: 350px'"
        :single-line="true"
        :hide-details="true"
        prepend-inner-icon="mdi-magnify"
        color="primary"
        @click="$emit('showSearchDialog')"
    >
        <template
            v-if="!value || value.length === 0"
            #default
        >
            <div
                class="text-grey-darken-2"
            >
                Click here to search
            </div>
        </template>
    </v-text-field>
</template>

<style scoped>
.custom-kbd {
    display: inline-grid;
    width: 18px;
    margin: 0 2px;
    height: 34px;
    padding: 0;
    background: transparent;
    border: 1px solid #616161;
    border-radius: 3px;
    box-shadow: none;
    align-items: center;
    justify-content: center;
}
</style>
